// extracted by mini-css-extract-plugin
module.exports = {"caption":"NFTMerchSection_caption__aVP8W","seeMore":"NFTMerchSection_seeMore__I5Pef"};